<script>
  import { navigate } from 'svelte-routing';
  import { isAuthenticated, user, showAlert } from '../lib/stores.js';
  
  // Form state
  let username = '';
  let password = '';
  let loading = false;
  let error = '';
  
  // Handle login form submission
  async function handleLogin(e) {
    e.preventDefault();
    
    // Basic validation
    if (!username || !password) {
      error = 'Username dan password harus diisi';
      return;
    }
    
    try {
      loading = true;
      error = '';
      
      const response = await fetch('/api/auth/login', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({ username, password })
      });
      
      const data = await response.json();
      
      if (data.success) {
        // Store token in local storage
        localStorage.setItem('token', data.token);
        
        // Update auth state using update method
        isAuthenticated.update(() => true);
        user.update(() => data.user);
        
        // Show success message
        showAlert('success', 'Login berhasil!');
        
        // Navigate to dashboard
        navigate('/dashboard');
      } else {
        error = data.message || 'Username atau password salah';
      }
    } catch (err) {
      console.error('Login error:', err);
      error = 'Terjadi kesalahan saat login';
    } finally {
      loading = false;
    }
  }
</script>

<div class="login-container">
  <div class="login-card">
    <div class="login-header">
      <h1>Sistem Manajemen Voucher</h1>
      <p>Silakan login untuk melanjutkan</p>
    </div>
    
    <form on:submit={handleLogin} class="login-form">
      {#if error}
        <div class="alert alert-error">
          {error}
        </div>
      {/if}
      
      <div class="form-group">
        <label for="username">Username</label>
        <input 
          type="text" 
          id="username" 
          bind:value={username} 
          placeholder="Masukkan username"
          disabled={loading}
          required
        />
      </div>
      
      <div class="form-group">
        <label for="password">Password</label>
        <input 
          type="password" 
          id="password" 
          bind:value={password} 
          placeholder="Masukkan password"
          disabled={loading}
          required
        />
      </div>
      
      <button 
        type="submit" 
        class="login-button" 
        disabled={loading}
      >
        {loading ? 'Memproses...' : 'Login'}
      </button>
    </form>
    
    <div class="login-footer">
      <p>&copy; {new Date().getFullYear()} Sistem Manajemen Voucher</p>
    </div>
  </div>
</div>

<style>
  .login-container {
    display: flex;
    justify-content: center;
    align-items: center;
    min-height: 100vh;
    padding: 1rem;
    background-color: #f5f7fa;
  }
  
  .login-card {
    width: 100%;
    max-width: 400px;
    background-color: white;
    border-radius: 8px;
    box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
    overflow: hidden;
  }
  
  .login-header {
    padding: 1.5rem;
    text-align: center;
    background-color: #2563eb;
    color: white;
  }
  
  .login-header h1 {
    margin: 0 0 0.5rem;
    font-size: 1.5rem;
    font-weight: 600;
  }
  
  .login-header p {
    margin: 0;
    opacity: 0.9;
  }
  
  .login-form {
    padding: 1.5rem;
  }
  
  .form-group {
    margin-bottom: 1rem;
  }
  
  .form-group label {
    display: block;
    margin-bottom: 0.5rem;
    font-weight: 500;
    color: #374151;
  }
  
  .form-group input {
    width: 100%;
    padding: 0.75rem;
    border: 1px solid #d1d5db;
    border-radius: 4px;
    font-size: 1rem;
    transition: border-color 0.2s;
  }
  
  .form-group input:focus {
    outline: none;
    border-color: #2563eb;
    box-shadow: 0 0 0 3px rgba(37, 99, 235, 0.1);
  }
  
  .login-button {
    width: 100%;
    padding: 0.75rem;
    background-color: #2563eb;
    color: white;
    border: none;
    border-radius: 4px;
    font-size: 1rem;
    font-weight: 500;
    cursor: pointer;
    transition: background-color 0.2s;
  }
  
  .login-button:hover {
    background-color: #1d4ed8;
  }
  
  .login-button:disabled {
    background-color: #93c5fd;
    cursor: not-allowed;
  }
  
  .login-footer {
    padding: 1rem;
    text-align: center;
    border-top: 1px solid #e5e7eb;
    color: #6b7280;
    font-size: 0.875rem;
  }
  
  .alert {
    padding: 0.75rem;
    margin-bottom: 1rem;
    border-radius: 4px;
    font-size: 0.875rem;
  }
  
  .alert-error {
    background-color: #fee2e2;
    color: #b91c1c;
    border: 1px solid #fecaca;
  }
  
  @media (max-width: 640px) {
    .login-card {
      max-width: 100%;
    }
  }
</style>